// extracted by mini-css-extract-plugin
export var header = "_av-0";